export default __webpack_public_path__ + "static/media/mobile-banner.a46b74ee.svg";